import { Instagram, Facebook } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#493E38] text-[#FBF7F2]">
    <div className="plaid h-3 w-full" aria-hidden="true" data-testid="footer-plaid-strip" />
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 pb-10">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mb-16">
        <div className="text-sm font-light space-y-1 text-[#FBF7F2]/70">
          <p data-testid="footer-contact-name">Caitlin Morrison</p>
          <p data-testid="footer-contact-phone">0400 105 941 · cmorrison@montelklending.com.au</p>
          <p data-testid="footer-contact-address">Mobile broker · Servicing clients Australia wide</p>
          <p data-testid="footer-domain">montelklending.com.au</p>
          <div className="flex items-center gap-5 pt-3">
            <a
              href="https://www.instagram.com/stravialending"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Mont Elk Lending on Instagram"
              data-testid="footer-instagram-link"
              className="text-[#FBF7F2]/60 hover:text-[#FBF7F2] transition-colors duration-300"
            >
              <Instagram size={18} strokeWidth={1.5} />
            </a>
            <a
              href="https://www.facebook.com/stravialending"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Mont Elk Lending on Facebook"
              data-testid="footer-facebook-link"
              className="text-[#FBF7F2]/60 hover:text-[#FBF7F2] transition-colors duration-300"
            >
              <Facebook size={18} strokeWidth={1.5} />
            </a>
          </div>
        </div>
        <a
          href="#top"
          data-testid="footer-back-to-top-link"
          className="text-xs font-semibold tracking-[0.3em] uppercase text-[#FBF7F2]/60 hover:text-[#FBF7F2] transition-colors duration-300"
        >
          Back to top
        </a>
      </div>
      <p className="text-xs tracking-wide text-[#FBF7F2]/50 max-w-2xl leading-relaxed mb-4">
        © 2026 Mont Elk Lending Pty Ltd. Credit is subject to assessment and
        lender approval. This site is not financial advice.
      </p>
      <p
        data-testid="footer-compliance"
        className="text-xs tracking-wide text-[#FBF7F2]/50 max-w-2xl leading-relaxed mb-12"
      >
        Stravia Lending Pty Ltd (ACN 700 755 264) is a Corporate Credit
        Representative (CRN 581106) of BLSSA Pty Ltd ACN 117 651 760,
        Australian Credit Licence Number 391237.
      </p>
      <p
        data-testid="footer-tagline"
        className="font-tagline text-xl md:text-2xl text-[#DBB89C] mb-6"
      >
        Guiding you home.
      </p>
      <p
        aria-hidden="true"
        className="font-display font-medium uppercase tracking-[0.12em] leading-none text-[13vw] md:text-[10vw] select-none -mb-2 bg-gradient-to-b from-[#EED9C2] via-[#DBB89C] to-[#B18A66] bg-clip-text text-transparent"
        data-testid="footer-wordmark"
      >
        Mont Elk
      </p>
    </div>
  </footer>
);
